import React from "react";
import Pitching from "../../../components/Pitching/Pitching";

function PitchingPage() {
  return <Pitching />;
}

export default PitchingPage;
